import { foldersDeletableItemDisplayText } from '../../constants';
import { BulkDeletionMixedActionWarningProps } from '../../types';

export const BulkDeletionMixedActionWarning = ({
  content,
  folders,
  displayTextForContentItems,
}: BulkDeletionMixedActionWarningProps) => {
  const folderOrFolders =
    foldersDeletableItemDisplayText.itemTypeName[folders.length > 1 ? 'plural' : 'singular'];
  const contentTypeName =
    displayTextForContentItems.itemTypeName[content.length > 1 ? 'plural' : 'singular'];
  const foldersDeletionAdjective = foldersDeletableItemDisplayText.actionName.adjective;
  const contentDeletionAdjective = displayTextForContentItems.actionName.adjective;

  return (
    <>
      (The {folderOrFolders} will be permanently {foldersDeletionAdjective}, and the{' '}
      {contentTypeName} will be {contentDeletionAdjective}.)
    </>
  );
};
